<template>
    <div class="start-page-bg">
        <div class="container start-page-container">
            <div class="row d-flex align-items-center justify-content-center vh-100">
                <div class="card text-center col-xl-5 col-lg-6 col-md-8">
                    <div class="card-body">
                        <div class="row justify-content-center" style="height: 45%;">
                            <h1 class="p-3 text-center" style="letter-spacing: 5px;color:#435666"> XSurflog </h1>
                        </div>
                        <hr />
                        <div class="row justify-content-center mt-3">
                            <h3> Validating... </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jwt_decode from 'jwt-decode'

export default ({
    async created() {
        await this.validate()
    },
    methods: {
        async validate() {
            const accessToken = this.$route.query.access_token;
            const orgSelected = this.$route.query.org_selected;
			
            if (typeof accessToken !== 'undefined') {
                try {
                    let decodedToken = jwt_decode(accessToken);

                    // Dispatch action and wait for all internal API responses to resolve safely
                    const isSuccess = await this.$store.dispatch("auth/handleAuthentication", {
                        accessToken,
                        decodedToken,
                        orgSelected
                    });

                    if (isSuccess && this.$store.state.auth.isAuthenticated) {
                        this.$router.push({ name: 'main' });
                    }
                } catch (error) {
                    console.error("Validation breakdown:", error);
                    this.$router.push({ name: 'index' });
                }
            } else {
                this.$router.push({ name: 'index' });
            }
        }
    }
})
</script>